import _sfc_main from "./Banner.vue2.js";
/* empty css            */
import _export_sfc from "../../_virtual/_plugin-vue_export-helper.js";
const Banner = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-e0ea893b"]]);
export {
  Banner as default
};
//# sourceMappingURL=Banner.vue.js.map
